/**
 * `DomainChip` — ADR-0186 S5. The onboarding Skills step's domain
 * display, shown as plain text.
 *
 * The "change" affordance (an inline PATCH /v1/sites editor) was
 * removed 2026-10-20 per founder report: Step 2 (Skills) must not let
 * the merchant switch or edit the domain mid-flow — a typo belongs on
 * Step 1 (Add site), not here, and swapping the site mid-flow re-grounds
 * every downstream signal (scan, platform read, suggestions) in ways
 * that leave the step inconsistent. Changing a pending site's domain
 * stays supported on the sites list surface. The server-side rescan
 * wiring in the sites PATCH route is unchanged.
 */

import { useSites } from '../../app/providers.js';
import { useC } from '../../lib/theme.js';

const sansFont = "'Geist', sans-serif";
const monoFont = "'JetBrains Mono', monospace";

export function DomainChip(): JSX.Element | null {
  const C = useC();
  const { activeSite } = useSites();

  if (activeSite === null) return null;

  return (
    <div
      className="flex items-center gap-2 mb-4"
      style={{ fontFamily: sansFont, fontSize: 13, color: C.muted }}
      data-testid="domain-chip"
    >
      <span style={{ fontFamily: monoFont, fontSize: 13, color: C.text }}>
        {activeSite.domain}
      </span>
    </div>
  );
}
